import "./index.css";

export const ComprobantesInstantaneos = () => {
  return (
    <div className="container">
      <div className="indicator">
        <h1>Consulta comprobantes instantaneos</h1>
      </div>
    </div>
  );
};
